import axios from "axios";
import { getToken, clearToken } from "./../utils/token";
import { config } from "../config/env";
const API_URL = config.apiUrl;
const api = axios.create({
    baseURL: `${API_URL}/api/v1`,
  });  
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      clearToken();
      window.location.href = "/sign-in";
    }
    return Promise.reject(err);
  }
);

export default api;
